import React, { ReactNode } from 'react'
import { ParameterType, Type } from './apireftypes';
import { ApiParameter } from './apiparameter';
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { Util } from '../fasades/util';
import './apiendpoint.css';
import './apiparameter.css';

interface Props {
    outputType : ParameterType;
}

interface State
{
    show : boolean;
}

export class ApiOutput extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            show : Util.isPrerendering()
        };
    }

    handleShowHide()
    {
        this.setState( { show : !this.state.show } );
    }

    render() {
        const { outputType } = this.props;

        return (
            <div className="parameters" suppressHydrationWarning={true}>
                <h2>Output</h2>
                <div className="parameter" suppressHydrationWarning={true}>
                    <hr/>
                    <div className="parameterTitle" onClick = { () => { this.handleShowHide() } } >
                        { this.renderTypeIcon() }
                        <h3>{ outputType.name }</h3>
                    </div>
                    { this.state.show && (
                        <>
                            { outputType.description && (
                                <div className="parameterDescription">{ outputType.description }</div>
                            )}
                            { this.renderTypeContent() }
                        </>
                    )}
                </div>
            </div>
        )
    }

    renderTypeIcon() : ReactNode
    {
        const icon = this.state.show ? IoIosArrowDown : IoIosArrowForward;
        return React.createElement(icon as React.ComponentType);
    }

    renderType() : ReactNode 
    {
        const { outputType } = this.props;

        switch (outputType.type) {
            case Type.Array:
                if (outputType.childType) {
                    return (
                        <>
                            <span>Array of </span>
                            <span className="parameterType">{ outputType.childType.name }</span>
                        </>
                    );
                }
                return <span className="parameterType">Array</span>;

            case Type.Object:
                return <span className="parameterType">Object</span>;

            case Type.Enum:
                return <span className="parameterType">Enum</span>;

            case Type.Basic:
            default:
                return <span className="parameterType">{ outputType.name }</span>;
        }
    }

    renderTypeContent() : ReactNode
    {
        const { outputType } = this.props;

        switch (outputType.type) {
            case Type.Object:
                if (outputType.parameters && outputType.parameters.length > 0) {
                    return (
                        <div className="parameterDescription">
                            { outputType.parameters.map((param) => (
                                <ApiParameter key={param.name} parameter={param} />
                            ))}
                        </div>
                    );
                }
                return null;

            case Type.Array:
                if (outputType.childType) {
                    return (
                        <div className="parameterDescription">
                            <div className="parameter">
                                <hr/>
                                <div className="parameterTitle">
                                    <span className="parameterName">Array Item</span>
                                    <span className="parameterSepartor">:</span>
                                    <span className="parameterType">{ outputType.childType.name }</span>
                                </div>
                                { outputType.childType.description && (
                                    <div className="parameterDescription">{ outputType.childType.description }</div>
                                )}
                                { outputType.childType.parameters && outputType.childType.parameters.length > 0 && (
                                    <div className="parameterDescription">
                                        { outputType.childType.parameters.map((param) => (
                                            <ApiParameter key={param.name} parameter={param} />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                }
                return null;

            case Type.Enum:
                if (outputType.enumMembers && outputType.enumMembers.length > 0) {
                    return (
                        <div className="parameterDescription">
                            { outputType.enumMembers.map((member) => (
                                <div key={member.id} className="parameter">
                                    <hr/>
                                    <div className="parameterTitle">
                                        <span className="parameterName">{ member.name }</span>
                                        <span className="parameterSepartor">:</span>
                                        <span className="parameterType">{ member.id }</span>
                                    </div>
                                    { member.description && (
                                        <div className="parameterDescription">{ member.description }</div>
                                    )}
                                </div>
                            ))}
                        </div>
                    );
                }
                return null;

            case Type.Basic:
            default:
                return null;
        }
    }
}

